var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPagingNext = function SvgPagingNext(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6398_17555)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 25.8477,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(-90 2 25.8477)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 25.3477,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "rotate(-90 2.5 25.3477)",
    stroke: "#EAEDF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8505 13.8477C15.8505 13.9032 15.8394 13.9616 15.8172 14.0227C15.795 14.0838 15.7561 14.1366 15.7005 14.181L12.5505 17.3477C12.4727 17.4255 12.3783 17.4644 12.2672 17.4644C12.1561 17.4644 12.0616 17.4255 11.9839 17.3477C11.9061 17.2588 11.8672 17.1671 11.8672 17.0727C11.8672 16.9782 11.9061 16.8921 11.9839 16.8144L14.9505 13.8477L11.9839 10.881C11.9061 10.8032 11.8672 10.7144 11.8672 10.6144C11.8672 10.5144 11.9061 10.4255 11.9839 10.3477C12.0616 10.2699 12.1533 10.231 12.2589 10.231C12.3644 10.231 12.4561 10.2699 12.5339 10.3477L15.7005 13.5144C15.7561 13.5588 15.795 13.6088 15.8172 13.6644C15.8394 13.7199 15.8505 13.781 15.8505 13.8477Z",
    fill: "#2f5fed"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6398_17555",
    x: 0,
    y: 0.847656,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0696 0 0 0 0 0.215657 0 0 0 0 0.4104 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6398_17555"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6398_17555",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPagingNext);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "paging-next.8c5a71cb530fe225c2766d09acb8c405.svg";